import React, { useMemo } from 'react';
import { BeveledPanel } from '../Equipment/FabProcessTool/BeveledPanel';
import { getStockerMaterials } from './StockerMaterials';
import type { StockerRackLayout } from './stockerRackLayout';
import type { StockerDimensions } from './stockerTypes';

export type StockerRackFrameProps = {
  dims: StockerDimensions;
  rack: StockerRackLayout;
  opacity?: number;
};

/** Vertical divider rails between bay columns — no opaque back wall. */
export const StockerRackFrame: React.FC<StockerRackFrameProps> = ({
  dims,
  rack,
  opacity = 1,
}) => {
  const mats = useMemo(() => getStockerMaterials(opacity), [opacity]);
  const { width, rackBottom, rackTop } = dims;
  const railBottom = rackBottom;
  const railH = rackTop - railBottom;
  const railY = (rackTop + railBottom) * 0.5;
  const railT = width * 0.008;
  const r = Math.min(width, dims.depth) * 0.006;

  const dividerXs = useMemo(() => {
    const xs = rack.slots.map((s) => s.position[0]);
    const sorted = [...new Set(xs.map((x) => Math.round(x * 100) / 100))].sort((a, b) => a - b);
    const rails: number[] = [0];
    for (let i = 0; i < sorted.length - 1; i++) {
      rails.push((sorted[i]! + sorted[i + 1]!) * 0.5);
    }
    return rails;
  }, [rack.slots]);

  return (
    <group name="StockerRackFrame">
      {dividerXs.map((x, i) => (
        <BeveledPanel
          key={`rack-rail-${i}`}
          size={[railT, railH * 0.92, rack.slotD * 0.95]}
          material={mats.brushedMetal}
          position={[x, railY, 0]}
          radius={r}
        />
      ))}
    </group>
  );
};

export default StockerRackFrame;
